var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultDeviderNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 179145",
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6641",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "2 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146607",
    transform: "translate(4 4)",
    style: {
      fill: "#e1e1e1"
    },
    d: "M0 0h166v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 179164"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29615",
    d: "M1 .533A.533.533 0 0 1 1.533 0h12.8a.533.533 0 1 1 0 1.067h-4.8v4.266A1.067 1.067 0 0 1 8.467 6.4H7.4a1.067 1.067 0 0 1-1.067-1.067V1.067h-4.8A.533.533 0 0 1 1 .533zM7.4 9.6a1.067 1.067 0 0 0-1.067 1.067v4.267h-4.8a.533.533 0 1 0 0 1.067h12.8a.533.533 0 1 0 0-1.067h-4.8v-4.267A1.067 1.067 0 0 0 8.467 9.6z",
    transform: "translate(79 12)",
    style: {
      fillRule: "evenodd",
      fill: "#231f20"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13496"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5551",
    transform: "translate(71 19.75)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h5.599v.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5558",
    transform: "translate(84.063 19.75)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h5.599v.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5556",
    transform: "translate(77.532 19.75)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h5.599v.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5557",
    transform: "translate(90.595 19.75)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h5.599v.5H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5559",
    transform: "translate(97.127 19.75)",
    style: {
      fill: "#231f20"
    },
    d: "M0 0h5.599v.5H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDeviderNewIcon);
export default __webpack_public_path__ + "static/media/default_devider_new_icon.30f271bb88270226e049e4d47defed93.svg";
export { ForwardRef as ReactComponent };